/**
 * Extension → content_type mapping for files accepted by the ingest pipeline.
 * Mirrors the server's ALLOWED_INGEST_CONTENT_TYPES; client filter step uses
 * this to drop unsupported files BEFORE hashing so the user gets immediate
 * feedback.
 */
const MAP: Record<string, string> = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  webp: 'image/webp',
};

export function contentTypeFor(filename: string): string | null {
  const idx = filename.lastIndexOf('.');
  if (idx < 0) return null;
  const ext = filename.slice(idx + 1).toLowerCase();
  return MAP[ext] ?? null;
}

/**
 * Files we silently skip on the client side: OS-level metadata, dotfiles,
 * and Thumbs.db. Surface these in the upload report as "skipped" not "failed".
 */
export function shouldSkip(filename: string): boolean {
  if (filename.startsWith('.')) return true;
  if (filename === 'Thumbs.db') return true;
  return false;
}
